const ROOT = 'dashboard/settings/owners/domus/'

export default {
	store: `${ROOT}store-on-mobili`
}
